/**
 * Icon mapping utilities for product symbols
 * Based on the original icon-mapper-factory.js from CommodityBookWebsiteOld
 */

export const createApprovedStatusToIconMapper = () => {
    return (status: boolean) => {
        return status ? '/assets/images/SignalGo.png' : '/assets/images/SignalStop.png';
    };
};

export const createMarpolRegulationToIconMapper = () => {
    return (regulation: number) => {
        switch (regulation) {
            case 1:
                return '/assets/images/AnnexI.png';
            case 2:
                return '/assets/images/AnnexII.png';
            default:
                return '';
        }
    };
};

export const createCleaningDifficultyToIconMapper = () => {
    return (difficulty: number) => {
        switch (difficulty) {
            case 1:
                return '/assets/images/Cleaning1.png';
            case 2:
                return '/assets/images/Cleaning2.png';
            case 3:
                return '/assets/images/Cleaning3.png';
            default:
                return '';
        }
    };
};

export const createIMDGCodeClassToIconMapper = () => {
    return (classification: string) => {
        const classNumber = classification?.[0];
        switch (classNumber) {
            case '1':
                return '/assets/images/HazardClass1.gif';
            case '2':
                return '/assets/images/HazardClass2.gif';
            case '3':
                return '/assets/images/HazardClass3.gif';
            case '4':
                return '/assets/images/HazardClass4.gif';
            case '5':
                return '/assets/images/HazardClass52.gif';
            case '6':
                return '/assets/images/HazardClass6.gif';
            case '7':
                return '/assets/images/HazardClass7.gif';
            case '8':
                return '/assets/images/HazardClass8.gif';
            case '9':
                return '/assets/images/HazardClass9.gif';
            default:
                return '';
        }
    };
};

export const createIBCShipTypeToIconMapper = () => {
    return () => {
        // Note: IBCShipType icons are missing, fallback to empty string
        // These would map to IBCShipType1.png, IBCShipType2.png, IBCShipType2K.png, IBCShipType3.png
        return '';
    };
};

// Enum to string mappers
export const marpolPollutionEnumToStringMapper = (category: number): string => {
    switch (category) {
        case 1:
            return 'X';
        case 2:
            return 'Y';
        case 3:
            return 'Z';
        default:
            return '';
    }
};

export const ibcShipTypeEnumToStringMapper = (shipType: number): string => {
    switch (shipType) {
        case 1:
            return '1';
        case 2:
            return '2';
        case 3:
            return '2K';
        case 4:
            return '3';
        default:
            return '';
    }
};

// Icon mappers instances
export const approvedStatusToIconMapper = createApprovedStatusToIconMapper();
export const marpolRegulationToIconMapper = createMarpolRegulationToIconMapper();
export const cleaningDifficultyToIconMapper = createCleaningDifficultyToIconMapper();
export const imdgCodeClassToIconMapper = createIMDGCodeClassToIconMapper();
export const ibcShipTypeToIconMapper = createIBCShipTypeToIconMapper();